import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  Link,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  SuppliesTableColumns,
  SuppliesTableRow,
} from "../../../core/models/supplies/supplies.model";
import "./SuppliesTable.scss";
import { useNavigate } from "react-router-dom";
import { setSupplySelectedToLocalStorage } from "../../../core/services/localStorage/localStorage.service";

interface SuppliesTableProps {
  suppliesTableRows: SuppliesTableRow[];
  isAdministrator: boolean | undefined;
}

const SuppliesTable = ({
  suppliesTableRows,
  isAdministrator,
}: SuppliesTableProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const suppliesTableColumns: SuppliesTableColumns[] = [
    ...(isAdministrator
      ? [
          {
            id: "socialReason",
            label: "Razón social",
            align: "left",
            width: "8%",
          },
          {
            id: "cif",
            label: "CIF",
            align: "left",
            width: "3%",
          },
        ]
      : []),
    {
      id: "suppliesDirection",
      label: "Dirección de suministro",
      align: "left",
      width: "15%",
    },
    {
      id: "town",
      label: "Localidad",
      align: "left",
      width: "8%",
    },
    {
      id: "rate",
      label: "Tarifa",
      align: "left",
      width: "5%",
    },
    {
      id: "bills",
      label: "Facturas",
      align: "left",
      width: "8%",
      cellContent: (row: SuppliesTableRow) => (
        <Link
          component="button"
          onClick={() => {
            setSupplySelectedToLocalStorage(row);
            navigate(
              `${process.env.REACT_APP_BILLS}/${row.bills.cupId}?origin=supplies`
            );
          }}
          underline="always"
        >{`${row.bills.billsNumber} ${t("Tablas.Facturas")}`}</Link>
      ),
    },
    {
      id: "cups",
      label: "CUPS",
      align: "left",
      width: "20%",
      cellContent: (row: SuppliesTableRow) => (
        <Link
          component="button"
          onClick={() => {
            setSupplySelectedToLocalStorage(row);
            navigate(
              `${process.env.REACT_APP_SUPPLIES}/${row.cups.cupId}?origin=supplies`
            );
          }}
          underline="always"
        >
          {row.cups.cupCode}
        </Link>
      ),
    },
  ];

  return (
    <TableContainer className="supplies-table">
      <Table>
        <TableHead>
          <TableRow>
            {suppliesTableColumns.map(({ id, align, width, label }) => (
              <TableCell key={id} align={align} width={width}>
                <Typography>{t(`Tablas.${label}`)}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {!!suppliesTableRows.length &&
            suppliesTableRows.map((row, indexNumber) => {
              return (
                <TableRow
                  key={`${row.id}_${indexNumber}`}
                  className={`table-row ${
                    row.cups.contractState !== "Contrato" ? "terminated" : ""
                  }`}
                >
                  {suppliesTableColumns.map(
                    ({ id, width, align, cellContent }) => {
                      const cellValue = row[id as keyof SuppliesTableRow];
                      return (
                        <TableCell
                          key={`${row.id}_${id}`}
                          align={align}
                          width={width}
                        >
                          {cellContent
                            ? cellContent(row)
                            : (cellValue as string)}
                        </TableCell>
                      );
                    }
                  )}
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SuppliesTable;
